// // import React, { useState, useEffect } from 'react';
// // import { Link, useParams, useNavigate } from "react-router-dom";
// // import axios from "../../Axiosinstance";
// // import {
// //   Box,
// //   Button,
// //   Table,
// //   TableBody,
// //   TableCell,
// //   TableContainer,
// //   TableHead,
// //   TableRow,
// //   Paper,
// //   TablePagination,
// //   Modal,
// //   TextField, Divider,
// //   MenuItem, Typography,
// // } from '@mui/material';
// // import Header from '../../components/Header'
// // import { CLOUDINARY_UPLOAD_PRESET, baseURL,timestamp } from '../../common'
// // import { format } from 'date-fns';
// // import { toast, ToastContainer } from 'react-toastify';
// // import { decryptData } from '../../Axiosinstance';

// // const App = () => {
// //   const [rows, setRows] = useState([]);
// //   const [open, setOpen] = useState(false);
// //   const [page, setPage] = useState(0);
// //   const [rowsPerPage, setRowsPerPage] = useState(5);
// //   // const { id } = useParams();
// //   const { id: encodedBatchId } = useParams(); // Get encoded batchId
// //   const id = decryptData(encodedBatchId); // Decode & Decrypt
// //   const [batchData, setBatchData] = useState(null);
// //   const [assessmentData, setAssessmentData] = useState(null);
// //   const [fileUploaded, setFileUploaded] = useState(false);

// //   const [formData, setFormData] = useState({
// //     batchId: 0,
// //     description: '',
// //     moduleName: '',
// //     url: ''
// //   });

// //   const CLOUDINARY_URL = baseURL;
// //   const CLOUDINARY_UPLOAD = CLOUDINARY_UPLOAD_PRESET;

// //   useEffect(() => {
// //     fetchBatchData();
// //     fetchAssessmentData();
// //   }, []);

// //   const handleOpen = () => setOpen(true);
// //   const handleClose = () => {
// //     setOpen(false);
// //     setFormData({ batchId: '', description: '', moduleName: '', url: '' });
// //   };

// //   const handleChangePage = (event, newPage) => {
// //     setPage(newPage);
// //   };

// //   const handleChangeRowsPerPage = (event) => {
// //     setRowsPerPage(parseInt(event.target.value, 10));
// //     setPage(0);
// //   };

// //   const handleDelete = async (id) => {
// //     const isConfirmed = window.confirm("Are you sure you want to delete this assessment?");
// //     if (!isConfirmed) return; // If user cancels, exit function
  
// //     try {
// //       console.log(id);
// //       await axios.delete(`trent_assessments/${id}`); // Call the delete API
// //       setRows((prevRows) => prevRows.filter((row) => row.id !== id)); // Update the state
// //       toast.success("Assessment deleted successfully");
// //     } catch (error) {
// //       console.error("Error deleting item:", error); // Handle errors
// //     }
// //   };
  



// //   const [editingIndex, setEditingIndex] = useState(null);

// //   const handleEdit = (index) => {
// //     const rowToEdit = rows[index];
// //     setFormData({
// //       batchId: rowToEdit.batchId,
// //       description: rowToEdit.description,
// //       moduleName: rowToEdit.moduleName, // Extract module number
// //       url: rowToEdit.url,
// //     });
// //     setEditingIndex(index);
// //     setOpen(true);
// //   };

// //   const fetchBatchData = async () => {
// //     try {
// //       const response = await axios.get(`batch/${id}`);
// //       setBatchData(response.data);
// //       console.log(response.data, "newdata");
// //     } catch (error) {
// //       console.error("Error fetching students:", error);
// //     }
// //   };

// //   const fetchAssessmentData = async () => {
// //     try {
// //       const response = await axios.get(`trent_assessments/${id}`);
// //       setRows(response.data);
// //       console.log(response.data, "newdata");
// //     } catch (error) {
// //       console.error("Error fetching students:", error);
// //     }
// //   };

// //   const handleSave = async () => {
// //     console.log("Saving data:", formData);

// //     if (editingIndex !== null) {
// //       // Update existing row
// //       const updatedRow = {
// //         batchId: id,
// //         description: formData.description,
// //         moduleName: formData.moduleName,
// //         url: formData.url,
// //       };

// //       // Call the API to update the existing row
// //       await axios.put(`trent_assessments/${rows[editingIndex].id}`, updatedRow);
// //       console.log("Updated row:", updatedRow);
// //     } else {
// //       // Add new row
// //       const newRow = {
// //         batchId: id,
// //         description: formData.description,
// //         moduleName: formData.moduleName,
// //         url: formData.url,
// //       };

// //       await axios.post(`trent_assessments/upload`, newRow);
// //       console.log("New row added:", newRow);
// //       setFileUploaded(false);
// //     }

// //     fetchAssessmentData(); // Fetch updated assessment data
// //     handleClose(); // Close the modal after saving
// //   };

// //   const handleView = (url) => {
// //     console.log(url)
// //     if (url) {
// //       window.open(url, '_blank');
// //     } else {
// //       alert('No file uploaded');
// //     }
// //   };


// //   const handleChange = (e) => {
// //     const { name, value } = e.target;
// //     setFormData((prevData) => ({
// //       ...prevData,
// //       [name]: value,
// //     }));
// //   };

// //   const handleFileChange = async (e) => {

// //     const selectedFile = e.target.files[0];
// //     if (selectedFile) {
// //       const formData = new FormData();
// //       // Append file and upload details to FormData
// //       formData.append('file', selectedFile);
// //       formData.append('upload_preset', CLOUDINARY_UPLOAD);
// //       formData.append('public_id', `LMS/Trent/${selectedFile.name} +' - '+ ${timestamp}`);

// //       try {
// //         const response = await fetch(baseURL, {
// //           method: 'POST',
// //           body: formData,
// //         });

// //         const data = await response.json();
// //         if (data.secure_url) {
// //           const profileUrl = data.secure_url; // Store the URL
// //           setFormData((prevData) => ({ ...prevData, url: profileUrl })); // Update formData with the profileUrl
// //           console.log("File uploaded successfully:", profileUrl);
// //           setFileUploaded(true);
// //         } else {
// //           throw new Error('Failed to upload image.');
// //         }
// //       } catch (error) {
// //         console.error("Error uploading file:", error);
// //         // Optionally, show an error message to the user here
// //       }
// //     }
// //   };

// //   // const formatCreatedAt = (dateString) => {
// //   //   const date = new Date(dateString);
// //   //   return `${date.toLocaleDateString()} ${date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true })}`;
// //   // };

// //   return (
// //     <div>
// //       <Header />
// //       <br />
// //       <Box p={6}>
// //         <TableContainer component={Paper}>
// //           <Box display="flex" justifyContent="flex-start" gap={2} mb={2}>
// //             <Link to="/Allcourse">
// //               <Button variant="contained"  style={{   backgroundColor: '#007bff' ,color:"white"  }}>
// //                 All Courses
// //               </Button>
// //             </Link>
// //             <Button variant="contained"  style={{   backgroundColor: '#007bff' ,color:"white"  }} onClick={handleOpen}>
// //               Add New Template
// //             </Button>
// //           </Box>

// //           <Table>
// //             <TableHead>
// //               <TableRow>
// //                 {/* <TableCell>Batch ID</TableCell> */}
// //                 <TableCell style={{ fontWeight: 'bold'}} >Description</TableCell>
// //                 <TableCell style={{ fontWeight: 'bold'}} >Uploaded Date and Time</TableCell>
// //                 <TableCell style={{ fontWeight: 'bold'}} >Module</TableCell>
// //                 <TableCell style={{ fontWeight: 'bold'}} >Action</TableCell>
// //               </TableRow> 
// //             </TableHead>
// //             <TableBody>
// //               {rows.length > 0 ? (
// //                 rows
// //                   .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
// //                   .map((row, index) => (
// //                     <TableRow key={index}>
// //                       {/* <TableCell>{row.batchId}</TableCell> */}
// //                       <TableCell>{row.description}</TableCell>
// //                       <TableCell>
// //                         {row.createdAt ? (
// //                           format(new Date(row.createdAt), 'dd/MM/yyyy HH:mm')
// //                         ) : (
// //                           'Invalid date'
// //                         )}
// //                       </TableCell>                      <TableCell>{row.moduleName}</TableCell>
// //                       <TableCell>
// //                         <Button
// //                           variant="outlined"
// //                           color="primary"
// //                           sx={{ marginRight: 1 }}
// //                           onClick={() => handleView(row.url)}
// //                         >
// //                           View
// //                         </Button>
// //                         <Button
// //                           variant="outlined"
// //                           color="success"
// //                           sx={{ marginRight: 1 }}
// //                           onClick={() => handleEdit(index)}
// //                         >
// //                           Edit
// //                         </Button>
// //                         <Button
// //                           variant="outlined"
// //                           color="error"
// //                           onClick={() => handleDelete(row.id)}
// //                         >
// //                           Delete
// //                         </Button>
// //                       </TableCell>
// //                     </TableRow>
// //                   ))
// //               ) : (
// //                 <TableRow>
// //                   <TableCell colSpan={5} align="center">
// //                     No data available
// //                   </TableCell>
// //                 </TableRow>
// //               )}
// //             </TableBody>
// //           </Table>
// //           <TablePagination
// //             rowsPerPageOptions={[5, 10, 15]}
// //             component="div"
// //             count={rows.length}
// //             rowsPerPage={rowsPerPage}
// //             page={page}
// //             onPageChange={handleChangePage}
// //             onRowsPerPageChange={handleChangeRowsPerPage}
// //           />
// //         </TableContainer>

// //         <Modal open={open} onClose={handleClose}>
// //           <Box
// //             component={Paper}
// //             p={4}
// //             sx={{
// //               width: '90%',
// //               maxWidth: 600,
// //               margin: 'auto',
// //               mt: '10%',
// //               display: 'flex',
// //               flexDirection: 'column',
// //               gap: 3,
// //               borderRadius: 2,
// //             }}
// //           >
// //             <Typography variant="h6" component="h2" textAlign="center" color="primary" gutterBottom>
// //               Add New Template
// //             </Typography>

// //             {/* <TextField
// //               label="Batch ID"
// //               value={formData.batchId}
// //               onChange={(e) => setFormData({ ...formData, batchId: e.target.value })}
// //               fullWidth
// //               variant="outlined"
// //             /> */}

// //             <TextField
// //               select
// //               label="Module"
// //               value={formData.moduleName}
// //               onChange={(e) => {
// //                 console.log("Module Value:", e.target.value);
// //                 setFormData({ ...formData, moduleName: e.target.value });
// //               }}
// //               fullWidth
// //               variant="outlined"
// //             >
// //               {batchData?.moduleDetails && batchData?.moduleDetails.length > 0 ? (
// //                 batchData.moduleDetails.map((module) => (
// //                   <MenuItem key={module.id} value={module.moduleName}>
// //                     {module.moduleName} {/* Displaying moduleName */}
// //                   </MenuItem>
// //                 ))
// //               ) : (
// //                 <MenuItem disabled>No modules available</MenuItem>
// //               )}
// //             </TextField>
// //             <TextField
// //               label="Description"
// //               value={formData.description}
// //               onChange={(e) => setFormData({ ...formData, description: e.target.value })}
// //               fullWidth
// //               multiline
// //               rows={3}
// //               variant="outlined"
// //             />
// //             {/* <TextField
// //               label="URL"
// //               value={formData.url}
// //               onChange={(e) => setFormData({ ...formData, url: e.target.value })}
// //               fullWidth
// //               variant="outlined"
// //             /> */}
// //             <TextField
// //               type="file"
// //               onChange={(event) => {
// //                 const file = event.target.files[0];
// //                 if (file && file.size > 8 * 1024 * 1024) {
// //                   event.target.value = ""; // Reset file input
// //                   alert("File size must be less than 8MB.");
// //                 } else {
// //                   handleFileChange(event);
// //                 }
// //               }}
// //               fullWidth
// //               variant="outlined"
// //               InputLabelProps={{ shrink: true }}
// //               label={formData.url ? "Reupload File" : "Upload File"}
// //             />
// //             <Box display="flex" justifyContent="flex-start" gap={2} mb={2}>
// //               <Button variant="contained" color="primary" disabled={!fileUploaded} onClick={handleSave}>
// //                 Save
// //               </Button>
// //               <Button variant="outlined" color="error" onClick={handleClose}>
// //                 Cancel
// //               </Button>
// //             </Box>
// //           </Box>
// //         </Modal>
// //       </Box>
// //       <ToastContainer position="bottom-right" autoClose={3000} hideProgressBar />

// //     </div>
// //   );
// // };

// // export default App;



// import React, { useState, useEffect } from 'react';
// import { Link, useParams } from "react-router-dom";
// import axios from "../../Axiosinstance";
// import {
//   Box, Button, Table, TableBody, TableCell, TableContainer,
//   TableHead, TableRow, Paper, TablePagination, Modal, TextField,
//   MenuItem, Typography, Chip, IconButton, Divider,
//   Radio, RadioGroup, FormControlLabel, FormLabel, Dialog,
//   DialogTitle, DialogContent, DialogActions, CircularProgress,
//   Alert
// } from '@mui/material';
// import AddIcon from '@mui/icons-material/Add';
// import DeleteIcon from '@mui/icons-material/Delete';
// import EditIcon from '@mui/icons-material/Edit';
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import Header from '../../components/Header';
// import { CLOUDINARY_UPLOAD_PRESET, baseURL, timestamp } from '../../common';
// import { format } from 'date-fns';
// import { toast, ToastContainer } from 'react-toastify';
// import { decryptData } from '../../Axiosinstance';

// // ─────────────────────────────────────────────────────────────────
// // MCQ View Dialog — admin views assessment questions + answers
// // ─────────────────────────────────────────────────────────────────
// const MCQViewDialog = ({ open, onClose, assessment }) => {
//   const [questions, setQuestions] = useState([]);
//   const [loading, setLoading]     = useState(false);

//   useEffect(() => {
//     if (open && assessment?.id) fetchQuestions();
//   }, [open, assessment]);

//   const fetchQuestions = async () => {
//     setLoading(true);
//     try {
//       const res = await axios.get(`assessment_questions/${assessment.id}`);
//       setQuestions(res.data);
//     } catch (err) {
//       toast.error("Failed to load questions");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const typeColors = {
//     MCQ: '#1976d2', TRUE_FALSE: '#388e3c',
//     MATCH: '#7b1fa2', SHORT_ANSWER: '#f57c00'
//   };

//   const totalMarks = questions.reduce((s, q) => s + (q.marks || 0), 0);

//   return (
//     <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth
//       PaperProps={{ sx: { maxHeight: '90vh' } }}>
//       <DialogTitle sx={{ borderBottom: '1px solid #e0e0e0', pb: 2 }}>
//         <Box display="flex" justifyContent="space-between" alignItems="center">
//           <Box>
//             <Typography variant="h6" fontWeight="bold">
//               Quiz Preview — {assessment?.description}
//             </Typography>
//             <Typography variant="body2" color="textSecondary">
//               Module: {assessment?.moduleName} · {questions.length} questions · {totalMarks} marks total
//             </Typography>
//           </Box>
//           <Chip label={`${questions.length} Qs`} color="primary" />
//         </Box>
//       </DialogTitle>

//       <DialogContent sx={{ p: 3 }}>
//         {loading ? (
//           <Box display="flex" justifyContent="center" py={6}>
//             <CircularProgress />
//           </Box>
//         ) : questions.length === 0 ? (
//           <Typography textAlign="center" color="textSecondary" py={4}>
//             No questions added yet.
//           </Typography>
//         ) : (
//           questions.map((q, index) => (
//             <Box key={q.id} sx={{
//               border: `2px solid ${typeColors[q.questionType] || '#ccc'}`,
//               borderRadius: 2, p: 2.5, mb: 2, backgroundColor: '#fafafa'
//             }}>
//               <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={1}>
//                 <Box sx={{ flex: 1 }}>
//                   <Typography fontWeight="bold">
//                     Q{index + 1}. {q.questionText}
//                   </Typography>
//                   <Box display="flex" gap={1} mt={0.5}>
//                     <Chip label={q.questionType} size="small"
//                       sx={{ backgroundColor: typeColors[q.questionType], color: 'white' }} />
//                     <Chip label={`${q.marks} mark${q.marks > 1 ? 's' : ''}`}
//                       size="small" color="info" variant="outlined" />
//                   </Box>
//                 </Box>
//               </Box>

//               <Divider sx={{ mb: 1.5 }} />

//               {/* MCQ Options with correct answer highlighted */}
//               {q.questionType === 'MCQ' && (
//                 <Box>
//                   <Typography variant="caption" fontWeight="bold" color="textSecondary" mb={1} display="block">
//                     OPTIONS (✓ = correct answer)
//                   </Typography>
//                   {q.options?.map((opt, i) => (
//                     <Box key={i} display="flex" alignItems="center" gap={1} mb={0.5} sx={{
//                       backgroundColor: opt.isCorrect ? '#e8f5e9' : 'transparent',
//                       borderRadius: 1, px: 1.5, py: 0.75,
//                       border: `1px solid ${opt.isCorrect ? '#4caf50' : '#e0e0e0'}`
//                     }}>
//                       <Typography variant="body2" sx={{
//                         fontWeight: opt.isCorrect ? 'bold' : 'normal',
//                         color: opt.isCorrect ? 'success.main' : 'inherit',
//                         flex: 1
//                       }}>
//                         {opt.optionText}
//                       </Typography>
//                       {opt.isCorrect && (
//                         <Chip label="✓ Correct" size="small" color="success"
//                           sx={{ height: 20, fontSize: '0.7rem' }} />
//                       )}
//                     </Box>
//                   ))}
//                 </Box>
//               )}

//               {/* TRUE/FALSE */}
//               {q.questionType === 'TRUE_FALSE' && (
//                 <Box>
//                   <Typography variant="caption" fontWeight="bold" color="textSecondary" mb={1} display="block">
//                     CORRECT ANSWER
//                   </Typography>
//                   <Box display="flex" gap={2}>
//                     {q.options?.map((opt, i) => (
//                       <Box key={i} sx={{
//                         border: `2px solid ${opt.isCorrect ? '#4caf50' : '#e0e0e0'}`,
//                         borderRadius: 1, px: 2.5, py: 1,
//                         backgroundColor: opt.isCorrect ? '#e8f5e9' : 'transparent',
//                         minWidth: 80, textAlign: 'center'
//                       }}>
//                         <Typography fontWeight={opt.isCorrect ? 'bold' : 'normal'}>
//                           {opt.optionText}
//                           {opt.isCorrect && ' ✓'}
//                         </Typography>
//                       </Box>
//                     ))}
//                   </Box>
//                 </Box>
//               )}

//               {/* MATCH Pairs */}
//               {q.questionType === 'MATCH' && (
//                 <Box>
//                   <Typography variant="caption" fontWeight="bold" color="textSecondary" mb={1} display="block">
//                     CORRECT PAIRS
//                   </Typography>
//                   {q.matchPairs?.map((pair, pi) => (
//                     <Box key={pi} display="flex" alignItems="center" gap={2} mb={0.5} sx={{
//                       backgroundColor: '#f3e5f5', borderRadius: 1, px: 1.5, py: 0.75
//                     }}>
//                       <Typography variant="body2" fontWeight="bold" sx={{ flex: 1 }}>
//                         {pair.leftItem}
//                       </Typography>
//                       <Typography color={typeColors.MATCH} fontWeight="bold">→</Typography>
//                       <Typography variant="body2" sx={{ flex: 1, color: 'success.main', fontWeight: 'bold' }}>
//                         {pair.rightItem}
//                       </Typography>
//                     </Box>
//                   ))}
//                 </Box>
//               )}

//               {/* SHORT ANSWER */}
//               {q.questionType === 'SHORT_ANSWER' && (
//                 <Box sx={{ backgroundColor: '#fff3e0', borderRadius: 1, p: 1.5 }}>
//                   <Typography variant="body2" color={typeColors.SHORT_ANSWER}>
//                     📝 Free-text response. Graded manually by the teacher.
//                     No predefined answer — teacher reviews and enters marks.
//                   </Typography>
//                 </Box>
//               )}
//             </Box>
//           ))
//         )}
//       </DialogContent>

//       <DialogActions sx={{ p: 2 }}>
//         <Button onClick={onClose} variant="contained">Close</Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// // ─────────────────────────────────────────────────────────────────
// // FILE Edit Dialog — edit description + re-upload file only
// // ─────────────────────────────────────────────────────────────────
// const FileEditDialog = ({ open, onClose, assessment, batchData, onSaved }) => {
//   const [description, setDescription] = useState('');
//   const [newFileUrl, setNewFileUrl]    = useState('');
//   const [fileUploaded, setFileUploaded] = useState(false);
//   const [saving, setSaving]            = useState(false);

//   const CLOUDINARY_URL    = baseURL;
//   const CLOUDINARY_UPLOAD = CLOUDINARY_UPLOAD_PRESET;

//   useEffect(() => {
//     if (assessment) {
//       setDescription(assessment.description || '');
//       setNewFileUrl('');
//       setFileUploaded(false);
//     }
//   }, [assessment]);

//   const handleFileChange = async (e) => {
//     const file = e.target.files[0];
//     if (!file) return;
//     const fd = new FormData();
//     fd.append('file', file);
//     fd.append('upload_preset', CLOUDINARY_UPLOAD);
//     fd.append('public_id', `LMS/Trent/${file.name} - ${timestamp}`);
//     try {
//       const res  = await fetch(CLOUDINARY_URL, { method: 'POST', body: fd });
//       const data = await res.json();
//       if (data.secure_url) {
//         setNewFileUrl(data.secure_url);
//         setFileUploaded(true);
//         toast.success("New file uploaded");
//       }
//     } catch {
//       toast.error("File upload failed");
//     }
//   };

//   const handleSave = async () => {
//     if (!description.trim()) {
//       toast.error("Description is required");
//       return;
//     }
//     setSaving(true);
//     try {
//       const payload = {
//         batchId:        assessment.batchId,
//         moduleName:     assessment.moduleName, // not editable
//         description,
//         url:            fileUploaded ? newFileUrl : assessment.url,
//         assessmentType: 'FILE',
//       };
//       await axios.put(`trent_assessments/${assessment.id}`, payload);
//       toast.success("Assessment updated");
//       onSaved();
//       onClose();
//     } catch {
//       toast.error("Failed to update");
//     } finally {
//       setSaving(false);
//     }
//   };

//   return (
//     <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
//       <DialogTitle>
//         <Typography variant="h6" fontWeight="bold">Edit File Assessment</Typography>
//         <Typography variant="body2" color="textSecondary">
//           Module: <strong>{assessment?.moduleName}</strong> (cannot be changed)
//         </Typography>
//       </DialogTitle>

//       <DialogContent sx={{ pt: 2 }}>
//         <Alert severity="info" sx={{ mb: 2 }}>
//           You can only edit the <strong>description</strong> and optionally replace the file.
//           The module cannot be changed.
//         </Alert>

//         <TextField
//           label="Description" fullWidth multiline rows={3}
//           value={description} sx={{ mb: 2 }}
//           onChange={e => setDescription(e.target.value)}
//         />

//         <Box sx={{ border: '1px dashed #ccc', borderRadius: 1, p: 2, mb: 1 }}>
//           <Typography variant="body2" color="textSecondary" mb={1}>
//             Current file: {assessment?.url
//               ? <a href={assessment.url} target="_blank" rel="noreferrer">View current file</a>
//               : 'No file'}
//           </Typography>
//           <TextField
//             type="file" fullWidth variant="outlined"
//             InputLabelProps={{ shrink: true }}
//             label="Replace File (optional)"
//             onChange={e => {
//               const file = e.target.files[0];
//               if (file && file.size > 8 * 1024 * 1024) {
//                 e.target.value = "";
//                 alert("File size must be less than 8MB.");
//               } else {
//                 handleFileChange(e);
//               }
//             }}
//           />
//           {fileUploaded && (
//             <Typography variant="caption" color="success.main" mt={0.5} display="block">
//               ✓ New file ready to save
//             </Typography>
//           )}
//         </Box>
//       </DialogContent>

//       <DialogActions sx={{ p: 2 }}>
//         <Button onClick={onClose} variant="outlined" color="error">Cancel</Button>
//         <Button onClick={handleSave} variant="contained" disabled={saving}>
//           {saving ? <CircularProgress size={20} sx={{ mr: 1 }} /> : null}
//           Save Changes
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// // ─────────────────────────────────────────────────────────────────
// // QUIZ Edit Dialog — edit description + questions text only
// //                   (options/answers NOT editable)
// // ─────────────────────────────────────────────────────────────────
// const QuizEditDialog = ({ open, onClose, assessment, onSaved }) => {
//   const [description, setDescription] = useState('');
//   const [questions, setQuestions]     = useState([]);
//   const [loading, setLoading]         = useState(false);
//   const [saving, setSaving]           = useState(false);

//   useEffect(() => {
//     if (open && assessment) {
//       setDescription(assessment.description || '');
//       fetchQuestions();
//     }
//   }, [open, assessment]);

//   const fetchQuestions = async () => {
//     setLoading(true);
//     try {
//       const res = await axios.get(`assessment_questions/${assessment.id}`);
//       setQuestions(res.data);
//     } catch {
//       toast.error("Failed to load questions");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleQuestionTextChange = (qIdx, value) => {
//     setQuestions(prev => {
//       const updated = [...prev];
//       updated[qIdx] = { ...updated[qIdx], questionText: value };
//       return updated;
//     });
//   };

//   const handleSave = async () => {
//     if (!description.trim()) {
//       toast.error("Description is required");
//       return;
//     }
//     setSaving(true);
//     try {
//       // 1. Update assessment header
//       await axios.put(`trent_assessments/${assessment.id}`, {
//         batchId:        assessment.batchId,
//         moduleName:     assessment.moduleName,
//         description,
//         url:            assessment.url,
//         assessmentType: 'QUIZ',
//       });

//       // 2. Update each question text (only text, not options)
//       for (const q of questions) {
//         await axios.put(`assessment_questions/${q.id}`, {
//           trentAssessmentId: assessment.id,
//           questionText:      q.questionText,
//           questionType:      q.questionType,
//           marks:             q.marks,
//           orderIndex:        q.orderIndex,
//           options:           q.options || [],
//           matchPairs:        q.matchPairs || [],
//         });
//       }

//       toast.success("Quiz updated successfully");
//       onSaved();
//       onClose();
//     } catch {
//       toast.error("Failed to update quiz");
//     } finally {
//       setSaving(false);
//     }
//   };

//   const typeColors = {
//     MCQ: '#1976d2', TRUE_FALSE: '#388e3c',
//     MATCH: '#7b1fa2', SHORT_ANSWER: '#f57c00'
//   };

//   return (
//     <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth
//       PaperProps={{ sx: { maxHeight: '90vh' } }}>
//       <DialogTitle>
//         <Typography variant="h6" fontWeight="bold">Edit Quiz Assessment</Typography>
//         <Typography variant="body2" color="textSecondary">
//           Module: <strong>{assessment?.moduleName}</strong> (cannot be changed)
//         </Typography>
//       </DialogTitle>

//       <DialogContent sx={{ pt: 2 }}>
//         <Alert severity="info" sx={{ mb: 2 }}>
//           You can edit the <strong>description</strong> and <strong>question text</strong>.
//           Options and correct answers <strong>cannot</strong> be changed to preserve result integrity.
//         </Alert>

//         <TextField
//           label="Description" fullWidth multiline rows={2}
//           value={description} sx={{ mb: 3 }}
//           onChange={e => setDescription(e.target.value)}
//         />

//         {loading ? (
//           <Box display="flex" justifyContent="center" py={4}>
//             <CircularProgress />
//           </Box>
//         ) : (
//           questions.map((q, qIdx) => (
//             <Box key={q.id} sx={{
//               border: `2px solid ${typeColors[q.questionType] || '#ccc'}`,
//               borderRadius: 2, p: 2, mb: 2, backgroundColor: '#fafafa'
//             }}>
//               <Box display="flex" gap={1} alignItems="center" mb={1}>
//                 <Chip label={`Q${qIdx + 1}`} size="small" />
//                 <Chip label={q.questionType} size="small"
//                   sx={{ backgroundColor: typeColors[q.questionType], color: 'white' }} />
//                 <Chip label={`${q.marks} mark${q.marks > 1 ? 's' : ''}`}
//                   size="small" color="info" variant="outlined" />
//                 <Typography variant="caption" color="textSecondary" sx={{ ml: 'auto' }}>
//                   Question text only — options locked
//                 </Typography>
//               </Box>

//               <TextField
//                 label={`Question ${qIdx + 1} Text`}
//                 fullWidth multiline rows={2} size="small"
//                 value={q.questionText}
//                 onChange={e => handleQuestionTextChange(qIdx, e.target.value)}
//                 sx={{ mb: 1 }}
//               />

//               {/* Read-only options preview */}
//               {(q.questionType === 'MCQ' || q.questionType === 'TRUE_FALSE') && q.options?.length > 0 && (
//                 <Box sx={{ backgroundColor: '#f5f5f5', borderRadius: 1, p: 1 }}>
//                   <Typography variant="caption" color="textSecondary" fontWeight="bold">
//                     OPTIONS (read-only):
//                   </Typography>
//                   {q.options.map((opt, i) => (
//                     <Box key={i} display="flex" alignItems="center" gap={1} mt={0.5}>
//                       <Box sx={{
//                         width: 8, height: 8, borderRadius: '50%',
//                         backgroundColor: opt.isCorrect ? '#4caf50' : '#bbb'
//                       }} />
//                       <Typography variant="caption" sx={{
//                         color: opt.isCorrect ? 'success.main' : 'inherit',
//                         fontWeight: opt.isCorrect ? 'bold' : 'normal'
//                       }}>
//                         {opt.optionText} {opt.isCorrect ? '✓' : ''}
//                       </Typography>
//                     </Box>
//                   ))}
//                 </Box>
//               )}

//               {q.questionType === 'MATCH' && q.matchPairs?.length > 0 && (
//                 <Box sx={{ backgroundColor: '#f5f5f5', borderRadius: 1, p: 1 }}>
//                   <Typography variant="caption" color="textSecondary" fontWeight="bold">
//                     MATCH PAIRS (read-only):
//                   </Typography>
//                   {q.matchPairs.map((pair, i) => (
//                     <Typography key={i} variant="caption" display="block" mt={0.5}>
//                       {pair.leftItem} → {pair.rightItem}
//                     </Typography>
//                   ))}
//                 </Box>
//               )}

//               {q.questionType === 'SHORT_ANSWER' && (
//                 <Box sx={{ backgroundColor: '#fff3e0', borderRadius: 1, p: 1 }}>
//                   <Typography variant="caption" color={typeColors.SHORT_ANSWER}>
//                     📝 Free-text. Manually graded.
//                   </Typography>
//                 </Box>
//               )}
//             </Box>
//           ))
//         )}
//       </DialogContent>

//       <DialogActions sx={{ p: 2 }}>
//         <Button onClick={onClose} variant="outlined" color="error">Cancel</Button>
//         <Button onClick={handleSave} variant="contained" disabled={saving}>
//           {saving ? <CircularProgress size={20} sx={{ mr: 1 }} /> : null}
//           Save Changes
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// // ─────────────────────────────────────────────────────────────────
// // Main Admin Assessment Page
// // ─────────────────────────────────────────────────────────────────
// const App = () => {
//   const { id: encodedBatchId } = useParams();
//   const id = decryptData(encodedBatchId);

//   const [rows, setRows]         = useState([]);
//   const [open, setOpen]         = useState(false);
//   const [page, setPage]         = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(5);
//   const [batchData, setBatchData]    = useState(null);
//   const [fileUploaded, setFileUploaded] = useState(false);

//   // Step tracking for QUIZ: 'form' | 'questions'
//   const [step, setStep]                   = useState('form');
//   const [savedAssessmentId, setSavedAssessmentId] = useState(null);

//   const [formData, setFormData] = useState({
//     description: '', moduleName: '', url: '', assessmentType: 'FILE',
//   });

//   const [questions, setQuestions] = useState([]);

//   // Edit dialogs
//   const [fileEditOpen, setFileEditOpen]   = useState(false);
//   const [quizEditOpen, setQuizEditOpen]   = useState(false);
//   const [viewQuizOpen, setViewQuizOpen]   = useState(false);
//   const [selectedAssessment, setSelectedAssessment] = useState(null);

//   // Delete confirmation
//   const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
//   const [deleteTarget, setDeleteTarget]         = useState(null);
//   const [deleteError, setDeleteError]           = useState('');
//   const [deleteChecking, setDeleteChecking]     = useState(false);

//   const CLOUDINARY_URL    = baseURL;
//   const CLOUDINARY_UPLOAD = CLOUDINARY_UPLOAD_PRESET;

//   useEffect(() => {
//     fetchBatchData();
//     fetchAssessmentData();
//   }, []);

//   const resetModal = () => {
//     setFormData({ description: '', moduleName: '', url: '', assessmentType: 'FILE' });
//     setQuestions([]);
//     setSavedAssessmentId(null);
//     setStep('form');
//     setFileUploaded(false);
//   };

//   const handleOpen  = () => { resetModal(); setOpen(true); };
//   const handleClose = () => { setOpen(false); resetModal(); };

//   const fetchBatchData = async () => {
//     try {
//       const res = await axios.get(`batch/${id}`);
//       setBatchData(res.data);
//     } catch (err) { console.error(err); }
//   };

//   const fetchAssessmentData = async () => {
//     try {
//       const res = await axios.get(`trent_assessments/${id}`);
//       setRows(res.data);
//     } catch (err) { console.error(err); }
//   };

//   // ── Delete with submission check ─────────────────────────────
//   const handleDeleteClick = async (row) => {
//     setDeleteTarget(row);
//     setDeleteError('');
//     setDeleteChecking(true);
//     setDeleteDialogOpen(true);

//     try {
//       // Check if any submissions exist for this assessment
//       const res = await axios.get(
//         row.assessmentType === 'QUIZ'
//           ? `quiz/submissions/count/${row.id}`
//           : `submissions/${row.id}`
//       );

//       const count = row.assessmentType === 'QUIZ'
//         ? (res.data?.count ?? res.data?.length ?? res.data ?? 0)
//         : (Array.isArray(res.data) ? res.data.length : 0);

//       if (count > 0) {
//         setDeleteError(
//           `Cannot delete: ${count} student submission${count > 1 ? 's' : ''} reference this assessment. Remove all submissions first.`
//         );
//       }
//     } catch (err) {
//       // If endpoint doesn't exist yet, allow delete (safe fallback)
//       console.warn("Could not check submissions:", err);
//     } finally {
//       setDeleteChecking(false);
//     }
//   };

//   const confirmDelete = async () => {
//     if (deleteError) return;
//     try {
//       await axios.delete(`trent_assessments/${deleteTarget.id}`);
//       setRows(prev => prev.filter(r => r.id !== deleteTarget.id));
//       toast.success("Deleted successfully");
//     } catch {
//       toast.error("Delete failed");
//     } finally {
//       setDeleteDialogOpen(false);
//       setDeleteTarget(null);
//     }
//   };

//   // ── Edit routing ─────────────────────────────────────────────
//   const handleEditClick = (row) => {
//     setSelectedAssessment({ ...row, batchId: id });
//     if (row.assessmentType === 'QUIZ') {
//       setQuizEditOpen(true);
//     } else {
//       setFileEditOpen(true);
//     }
//   };

//   // ── View Quiz ────────────────────────────────────────────────
//   const handleViewQuiz = (row) => {
//     setSelectedAssessment(row);
//     setViewQuizOpen(true);
//   };

//   const handleFileChange = async (e) => {
//     const file = e.target.files[0];
//     if (!file) return;
//     const fd = new FormData();
//     fd.append('file', file);
//     fd.append('upload_preset', CLOUDINARY_UPLOAD);
//     fd.append('public_id', `LMS/Trent/${file.name} - ${timestamp}`);
//     try {
//       const res  = await fetch(CLOUDINARY_URL, { method: 'POST', body: fd });
//       const data = await res.json();
//       if (data.secure_url) {
//         setFormData(prev => ({ ...prev, url: data.secure_url }));
//         setFileUploaded(true);
//         toast.success("File uploaded");
//       }
//     } catch {
//       toast.error("File upload failed");
//     }
//   };

//   // ── Step 1: Save new assessment ──────────────────────────────
//   const handleSaveAssessment = async () => {
//     if (!formData.moduleName || !formData.description) {
//       toast.error("Please fill Module and Description");
//       return;
//     }
//     const payload = {
//       batchId: id,
//       description: formData.description,
//       moduleName: formData.moduleName,
//       url: formData.assessmentType === 'FILE' ? formData.url : '',
//       assessmentType: formData.assessmentType,
//     };
//     try {
//       const response = await axios.post('trent_assessments/upload', payload);
//       if (formData.assessmentType === 'QUIZ') {
//         const newId = response.data?.id;
//         if (!newId) { toast.error("Failed to get assessment ID."); return; }
//         setSavedAssessmentId(newId);
//         setStep('questions');
//         toast.success("Assessment saved! Now add questions.");
//         fetchAssessmentData();
//       } else {
//         toast.success("Assessment created");
//         fetchAssessmentData();
//         handleClose();
//       }
//     } catch {
//       toast.error("Failed to save assessment");
//     }
//   };

//   // ── Step 2: Save all questions (new quiz) ────────────────────
//   const handleSaveAllQuestions = async () => {
//     if (questions.length === 0) { toast.error("Add at least one question"); return; }
//     for (let i = 0; i < questions.length; i++) {
//       const q = questions[i];
//       if (!q.questionText.trim()) { toast.error(`Question ${i + 1} text is empty`); return; }
//       if (q.questionType === 'MCQ' && q.options.filter(o => o.optionText.trim()).length < 2) {
//         toast.error(`Question ${i + 1} needs at least 2 options`); return;
//       }
//       if (q.questionType === 'MCQ' && !q.options.some(o => o.isCorrect)) {
//         toast.error(`Question ${i + 1}: select a correct answer`); return;
//       }
//       if (q.questionType === 'MATCH' && q.matchPairs.length < 1) {
//         toast.error(`Question ${i + 1} needs at least 1 match pair`); return;
//       }
//     }
//     try {
//       for (const q of questions) {
//         await axios.post('assessment_questions/add', {
//           trentAssessmentId: savedAssessmentId,
//           questionText: q.questionText,
//           questionType: q.questionType,
//           marks: q.marks,
//           orderIndex: q.orderIndex,
//           options: (q.questionType === 'MCQ' || q.questionType === 'TRUE_FALSE') ? q.options : [],
//           matchPairs: q.questionType === 'MATCH' ? q.matchPairs : [],
//         });
//       }
//       toast.success(`${questions.length} question(s) saved!`);
//       handleClose();
//     } catch {
//       toast.error("Failed to save questions");
//     }
//   };

//   // ── Question helpers ─────────────────────────────────────────
//   const addQuestion = () => {
//     setQuestions(prev => [...prev, {
//       questionText: '', questionType: 'MCQ', marks: 1, orderIndex: prev.length + 1,
//       options: [
//         { optionText: '', isCorrect: false }, { optionText: '', isCorrect: false },
//         { optionText: '', isCorrect: false }, { optionText: '', isCorrect: false },
//       ],
//       matchPairs: [],
//     }]);
//   };

//   const removeQuestion = (qIdx) => setQuestions(prev => prev.filter((_, i) => i !== qIdx));

//   const updateQuestion = (qIdx, field, value) => {
//     setQuestions(prev => {
//       const updated = [...prev];
//       updated[qIdx] = { ...updated[qIdx], [field]: value };
//       if (field === 'questionType') {
//         if (value === 'TRUE_FALSE') {
//           updated[qIdx].options = [
//             { optionText: 'True', isCorrect: true },
//             { optionText: 'False', isCorrect: false },
//           ];
//           updated[qIdx].matchPairs = [];
//         } else if (value === 'MCQ') {
//           updated[qIdx].options = [
//             { optionText: '', isCorrect: false }, { optionText: '', isCorrect: false },
//             { optionText: '', isCorrect: false }, { optionText: '', isCorrect: false },
//           ];
//           updated[qIdx].matchPairs = [];
//         } else if (value === 'MATCH') {
//           updated[qIdx].options = [];
//           updated[qIdx].matchPairs = [{ leftItem: '', rightItem: '' }, { leftItem: '', rightItem: '' }];
//         } else if (value === 'SHORT_ANSWER') {
//           updated[qIdx].options = [];
//           updated[qIdx].matchPairs = [];
//         }
//       }
//       return updated;
//     });
//   };

//   const updateOption = (qIdx, oIdx, field, value) => {
//     setQuestions(prev => {
//       const updated = [...prev];
//       const opts = [...updated[qIdx].options];
//       if (field === 'isCorrect') {
//         opts.forEach((o, i) => { opts[i] = { ...o, isCorrect: i === oIdx }; });
//       } else {
//         opts[oIdx] = { ...opts[oIdx], [field]: value };
//       }
//       updated[qIdx].options = opts;
//       return updated;
//     });
//   };

//   const addOption    = (qIdx) => setQuestions(prev => {
//     const updated = [...prev];
//     updated[qIdx].options.push({ optionText: '', isCorrect: false });
//     return updated;
//   });

//   const removeOption = (qIdx, oIdx) => setQuestions(prev => {
//     const updated = [...prev];
//     updated[qIdx].options = updated[qIdx].options.filter((_, i) => i !== oIdx);
//     return updated;
//   });

//   const updateMatchPair = (qIdx, pIdx, field, value) => {
//     setQuestions(prev => {
//       const updated = [...prev];
//       const pairs = [...updated[qIdx].matchPairs];
//       pairs[pIdx] = { ...pairs[pIdx], [field]: value };
//       updated[qIdx].matchPairs = pairs;
//       return updated;
//     });
//   };

//   const addMatchPair    = (qIdx) => setQuestions(prev => {
//     const updated = [...prev];
//     updated[qIdx].matchPairs.push({ leftItem: '', rightItem: '' });
//     return updated;
//   });

//   const removeMatchPair = (qIdx, pIdx) => setQuestions(prev => {
//     const updated = [...prev];
//     updated[qIdx].matchPairs = updated[qIdx].matchPairs.filter((_, i) => i !== pIdx);
//     return updated;
//   });

//   const isSaveDisabled = () => {
//     if (!formData.description || !formData.moduleName) return true;
//     if (formData.assessmentType === 'FILE' && !fileUploaded) return true;
//     return false;
//   };

//   const typeColors = {
//     MCQ: '#1976d2', TRUE_FALSE: '#388e3c',
//     MATCH: '#7b1fa2', SHORT_ANSWER: '#f57c00'
//   };

//   return (
//     <div>
//       <Header />
//       <br />
//       <Box p={4}>
//         <TableContainer component={Paper}>
//           <Box display="flex" gap={2} mb={2} p={1}>
//             <Link to="/Allcourse">
//               <Button variant="contained" sx={{ backgroundColor: '#007bff' }}>All Courses</Button>
//             </Link>
//             <Button variant="contained" sx={{ backgroundColor: '#007bff' }} onClick={handleOpen}>
//               Add New Template
//             </Button>
//           </Box>

//           <Table>
//             <TableHead>
//               <TableRow>
//                 <TableCell sx={{ fontWeight: 'bold' }}>Description</TableCell>
//                 <TableCell sx={{ fontWeight: 'bold' }}>Type</TableCell>
//                 <TableCell sx={{ fontWeight: 'bold' }}>Created At</TableCell>
//                 <TableCell sx={{ fontWeight: 'bold' }}>Module</TableCell>
//                 <TableCell sx={{ fontWeight: 'bold' }}>Actions</TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {rows.length > 0 ? (
//                 rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
//                   <TableRow key={index}>
//                     <TableCell>{row.description}</TableCell>
//                     <TableCell>
//                       <Chip label={row.assessmentType || 'FILE'}
//                         color={row.assessmentType === 'QUIZ' ? 'secondary' : 'primary'} size="small" />
//                     </TableCell>
//                     <TableCell>
//                       {row.createdAt ? format(new Date(row.createdAt), 'dd/MM/yyyy HH:mm') : 'N/A'}
//                     </TableCell>
//                     <TableCell>{row.moduleName}</TableCell>
//                     <TableCell>
//                       <Box display="flex" gap={0.5} flexWrap="wrap">
//                         {/* View — only for QUIZ */}
//                         {row.assessmentType === 'QUIZ' && (
//                           <Button variant="outlined" color="info" size="small"
//                             startIcon={<VisibilityIcon />}
//                             onClick={() => handleViewQuiz(row)}>
//                             View
//                           </Button>
//                         )}
//                         {/* View File — only for FILE */}
//                         {row.assessmentType !== 'QUIZ' && (
//                           <Button variant="outlined" color="primary" size="small"
//                             onClick={() => window.open(row.url, "_blank")}>
//                             View File
//                           </Button>
//                         )}
//                         {/* Edit */}
//                         <Button variant="outlined" color="success" size="small"
//                           startIcon={<EditIcon />}
//                           onClick={() => handleEditClick(row)}>
//                           Edit
//                         </Button>
//                         {/* Delete */}
//                         <Button variant="outlined" color="error" size="small"
//                           startIcon={<DeleteIcon />}
//                           onClick={() => handleDeleteClick(row)}>
//                           Delete
//                         </Button>
//                       </Box>
//                     </TableCell>
//                   </TableRow>
//                 ))
//               ) : (
//                 <TableRow>
//                   <TableCell colSpan={5} align="center">No data available</TableCell>
//                 </TableRow>
//               )}
//             </TableBody>
//           </Table>

//           <TablePagination rowsPerPageOptions={[5, 10, 15]} component="div"
//             count={rows.length} rowsPerPage={rowsPerPage} page={page}
//             onPageChange={(e, n) => setPage(n)}
//             onRowsPerPageChange={e => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); }} />
//         </TableContainer>

//         {/* ── CREATE Modal ─────────────────────────────────────── */}
//         <Modal open={open} onClose={handleClose}>
//           <Box component={Paper} sx={{
//             width: '90%', maxWidth: 750,
//             maxHeight: '90vh', overflowY: 'auto',
//             margin: 'auto', mt: '3%', p: 4, borderRadius: 2,
//           }}>
//             {step === 'form' && (
//               <>
//                 <Typography variant="h6" textAlign="center" color="primary" mb={2}>
//                   Add New Assessment
//                 </Typography>

//                 <Box mb={2}>
//                   <FormLabel sx={{ fontWeight: 'bold' }}>Assessment Type</FormLabel>
//                   <RadioGroup row value={formData.assessmentType}
//                     onChange={e => setFormData({ ...formData, assessmentType: e.target.value })}>
//                     <FormControlLabel value="FILE" control={<Radio />} label="File Upload" />
//                     <FormControlLabel value="QUIZ" control={<Radio />} label="Quiz (MCQ / T-F / Match / Short Answer)" />
//                   </RadioGroup>
//                 </Box>

//                 <TextField select label="Module" fullWidth variant="outlined" sx={{ mb: 2 }}
//                   value={formData.moduleName}
//                   onChange={e => setFormData({ ...formData, moduleName: e.target.value })}>
//                   {batchData?.moduleDetails?.length > 0
//                     ? batchData.moduleDetails.map(m => (
//                       <MenuItem key={m.id} value={m.moduleName}>{m.moduleName}</MenuItem>
//                     ))
//                     : <MenuItem disabled>No modules available</MenuItem>}
//                 </TextField>

//                 <TextField label="Description" fullWidth multiline rows={3}
//                   variant="outlined" sx={{ mb: 2 }}
//                   value={formData.description}
//                   onChange={e => setFormData({ ...formData, description: e.target.value })} />

//                 {formData.assessmentType === 'FILE' && (
//                   <TextField type="file" fullWidth variant="outlined"
//                     InputLabelProps={{ shrink: true }}
//                     label="Upload File" sx={{ mb: 2 }}
//                     onChange={e => {
//                       const file = e.target.files[0];
//                       if (file && file.size > 8 * 1024 * 1024) {
//                         e.target.value = ""; alert("File size must be less than 8MB.");
//                       } else { handleFileChange(e); }
//                     }} />
//                 )}

//                 <Box display="flex" gap={2}>
//                   <Button variant="contained" color="primary"
//                     disabled={isSaveDisabled()} onClick={handleSaveAssessment}>
//                     {formData.assessmentType === 'QUIZ'
//                       ? 'Save & Add Questions →' : 'Save'}
//                   </Button>
//                   <Button variant="outlined" color="error" onClick={handleClose}>Cancel</Button>
//                 </Box>
//               </>
//             )}

//             {step === 'questions' && (
//               <>
//                 <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
//                   <Box>
//                     <Typography variant="h6" color="primary" fontWeight="bold">Add Questions</Typography>
//                     <Typography variant="body2" color="textSecondary">
//                       Assessment ID: {savedAssessmentId} · {questions.length} question(s)
//                     </Typography>
//                   </Box>
//                   <Button variant="contained" color="primary" startIcon={<AddIcon />} onClick={addQuestion}>
//                     Add Question
//                   </Button>
//                 </Box>

//                 <Divider sx={{ mb: 2 }} />

//                 {questions.length === 0 && (
//                   <Box textAlign="center" py={4} sx={{ border: '2px dashed #ccc', borderRadius: 2 }}>
//                     <Typography color="textSecondary" mb={1}>No questions yet</Typography>
//                     <Button variant="outlined" startIcon={<AddIcon />} onClick={addQuestion}>
//                       Add First Question
//                     </Button>
//                   </Box>
//                 )}

//                 {questions.map((q, qIdx) => (
//                   <Box key={qIdx} sx={{
//                     border: `2px solid ${typeColors[q.questionType] || '#ccc'}`,
//                     borderRadius: 2, p: 2, mb: 2, backgroundColor: '#fafafa'
//                   }}>
//                     <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
//                       <Typography fontWeight="bold" color={typeColors[q.questionType]}>
//                         Question {qIdx + 1}
//                       </Typography>
//                       <IconButton color="error" size="small" onClick={() => removeQuestion(qIdx)}>
//                         <DeleteIcon />
//                       </IconButton>
//                     </Box>

//                     <Box display="flex" gap={2} mb={1}>
//                       <TextField select label="Question Type" size="small"
//                         value={q.questionType} sx={{ flex: 2 }}
//                         onChange={e => updateQuestion(qIdx, 'questionType', e.target.value)}>
//                         {Object.entries(typeColors).map(([type, color]) => (
//                           <MenuItem key={type} value={type}>
//                             <Box display="flex" alignItems="center" gap={1}>
//                               <Chip label={type} size="small" sx={{ backgroundColor: color, color: 'white' }} />
//                               {type === 'MCQ' ? 'Multiple Choice' : type === 'TRUE_FALSE' ? 'True / False'
//                                 : type === 'MATCH' ? 'Match the Following' : 'Short Answer'}
//                             </Box>
//                           </MenuItem>
//                         ))}
//                       </TextField>
//                       <TextField label="Marks" type="number" size="small"
//                         value={q.marks} sx={{ width: 90 }} inputProps={{ min: 1 }}
//                         onChange={e => updateQuestion(qIdx, 'marks', parseInt(e.target.value) || 1)} />
//                     </Box>

//                     <TextField label={`Question ${qIdx + 1} Text`} fullWidth multiline rows={2}
//                       size="small" value={q.questionText} sx={{ mb: 1 }}
//                       onChange={e => updateQuestion(qIdx, 'questionText', e.target.value)} />

//                     {/* MCQ */}
//                     {q.questionType === 'MCQ' && (
//                       <Box sx={{ backgroundColor: '#e3f2fd', borderRadius: 1, p: 1.5 }}>
//                         <Typography variant="body2" fontWeight="bold" color={typeColors.MCQ} mb={1}>
//                           Options — select the correct answer (●)
//                         </Typography>
//                         {q.options.map((opt, oIdx) => (
//                           <Box key={oIdx} display="flex" alignItems="center" gap={1} mb={0.5}>
//                             <Radio size="small" checked={opt.isCorrect}
//                               onChange={() => updateOption(qIdx, oIdx, 'isCorrect', true)}
//                               sx={{ color: typeColors.MCQ }} />
//                             <TextField size="small" fullWidth placeholder={`Option ${oIdx + 1}`}
//                               value={opt.optionText}
//                               onChange={e => updateOption(qIdx, oIdx, 'optionText', e.target.value)} />
//                             {q.options.length > 2 && (
//                               <IconButton size="small" color="error" onClick={() => removeOption(qIdx, oIdx)}>
//                                 <DeleteIcon fontSize="small" />
//                               </IconButton>
//                             )}
//                           </Box>
//                         ))}
//                         <Button size="small" startIcon={<AddIcon />} onClick={() => addOption(qIdx)} sx={{ mt: 0.5 }}>
//                           Add Option
//                         </Button>
//                       </Box>
//                     )}

//                     {/* TRUE/FALSE */}
//                     {q.questionType === 'TRUE_FALSE' && (
//                       <Box sx={{ backgroundColor: '#e8f5e9', borderRadius: 1, p: 1.5 }}>
//                         <Typography variant="body2" fontWeight="bold" color={typeColors.TRUE_FALSE} mb={1}>
//                           Select the correct answer
//                         </Typography>
//                         <RadioGroup row value={q.options.find(o => o.isCorrect)?.optionText || 'True'}
//                           onChange={e => setQuestions(prev => {
//                             const updated = [...prev];
//                             updated[qIdx].options = [
//                               { optionText: 'True', isCorrect: e.target.value === 'True' },
//                               { optionText: 'False', isCorrect: e.target.value === 'False' },
//                             ];
//                             return updated;
//                           })}>
//                           <FormControlLabel value="True" control={<Radio sx={{ color: typeColors.TRUE_FALSE }} />}
//                             label={<Typography fontWeight="bold">✓ True</Typography>} />
//                           <FormControlLabel value="False" control={<Radio sx={{ color: typeColors.TRUE_FALSE }} />}
//                             label={<Typography fontWeight="bold">✗ False</Typography>} />
//                         </RadioGroup>
//                       </Box>
//                     )}

//                     {/* MATCH */}
//                     {q.questionType === 'MATCH' && (
//                       <Box sx={{ backgroundColor: '#f3e5f5', borderRadius: 1, p: 1.5 }}>
//                         <Typography variant="body2" fontWeight="bold" color={typeColors.MATCH} mb={1}>
//                           Match Pairs — Left column → Right column
//                         </Typography>
//                         {q.matchPairs.map((pair, pIdx) => (
//                           <Box key={pIdx} display="flex" alignItems="center" gap={1} mb={0.5}>
//                             <TextField size="small" placeholder="Left item" value={pair.leftItem} sx={{ flex: 1 }}
//                               onChange={e => updateMatchPair(qIdx, pIdx, 'leftItem', e.target.value)} />
//                             <Typography color={typeColors.MATCH} fontWeight="bold">→</Typography>
//                             <TextField size="small" placeholder="Right item" value={pair.rightItem} sx={{ flex: 1 }}
//                               onChange={e => updateMatchPair(qIdx, pIdx, 'rightItem', e.target.value)} />
//                             {q.matchPairs.length > 1 && (
//                               <IconButton size="small" color="error" onClick={() => removeMatchPair(qIdx, pIdx)}>
//                                 <DeleteIcon fontSize="small" />
//                               </IconButton>
//                             )}
//                           </Box>
//                         ))}
//                         <Button size="small" startIcon={<AddIcon />} onClick={() => addMatchPair(qIdx)} sx={{ mt: 0.5 }}>
//                           Add Pair
//                         </Button>
//                       </Box>
//                     )}

//                     {/* SHORT ANSWER — shows expected answer field for reference */}
//                     {q.questionType === 'SHORT_ANSWER' && (
//                       <Box sx={{ backgroundColor: '#fff3e0', borderRadius: 1, p: 1.5 }}>
//                         <Typography variant="body2" color={typeColors.SHORT_ANSWER} mb={1}>
//                           📝 Student types a free-text answer. Graded manually by the teacher.
//                         </Typography>
//                         <TextField
//                           label="Model Answer / Marking Guide (optional — for teacher reference only)"
//                           fullWidth multiline rows={2} size="small"
//                           placeholder="Enter expected answer or marking criteria..."
//                           helperText="This is only visible to the teacher when grading, not shown to students."
//                         />
//                       </Box>
//                     )}
//                   </Box>
//                 ))}

//                 <Box display="flex" gap={2} mt={2}>
//                   <Button variant="contained" color="success"
//                     disabled={questions.length === 0} onClick={handleSaveAllQuestions}>
//                     Save All Questions ({questions.length}) ✓
//                   </Button>
//                   <Button variant="outlined" color="error" onClick={handleClose}>Cancel</Button>
//                 </Box>
//               </>
//             )}
//           </Box>
//         </Modal>
//       </Box>

//       {/* ── Delete Confirmation Dialog ───────────────────────── */}
//       <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)} maxWidth="sm" fullWidth>
//         <DialogTitle>Confirm Delete</DialogTitle>
//         <DialogContent>
//           {deleteChecking ? (
//             <Box display="flex" alignItems="center" gap={2}>
//               <CircularProgress size={20} />
//               <Typography>Checking for student submissions...</Typography>
//             </Box>
//           ) : deleteError ? (
//             <Alert severity="error">{deleteError}</Alert>
//           ) : (
//             <Typography>
//               Are you sure you want to delete <strong>"{deleteTarget?.description}"</strong>?
//               This action cannot be undone.
//             </Typography>
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setDeleteDialogOpen(false)} variant="outlined">Cancel</Button>
//           <Button onClick={confirmDelete} variant="contained" color="error"
//             disabled={!!deleteError || deleteChecking}>
//             Delete
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* ── FILE Edit Dialog ─────────────────────────────────── */}
//       <FileEditDialog
//         open={fileEditOpen}
//         onClose={() => setFileEditOpen(false)}
//         assessment={selectedAssessment}
//         batchData={batchData}
//         onSaved={fetchAssessmentData}
//       />

//       {/* ── QUIZ Edit Dialog ─────────────────────────────────── */}
//       <QuizEditDialog
//         open={quizEditOpen}
//         onClose={() => setQuizEditOpen(false)}
//         assessment={selectedAssessment}
//         onSaved={fetchAssessmentData}
//       />

//       {/* ── MCQ View Dialog ──────────────────────────────────── */}
//       <MCQViewDialog
//         open={viewQuizOpen}
//         onClose={() => setViewQuizOpen(false)}
//         assessment={selectedAssessment}
//       />

//       <ToastContainer position="bottom-right" autoClose={3000} hideProgressBar />
//     </div>
//   );
// };

// export default App;




import React, { useState, useEffect } from 'react';
import { Link, useParams } from "react-router-dom";
import axios from "../../Axiosinstance";
import {
  Box, Button, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper, TablePagination, Modal, TextField,
  MenuItem, Typography, Chip, IconButton, Divider,
  Radio, RadioGroup, FormControlLabel, FormLabel, Dialog,
  DialogTitle, DialogContent, DialogActions, CircularProgress,
  Alert
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Header from '../../components/Header';
import { CLOUDINARY_UPLOAD_PRESET, baseURL, timestamp } from '../../common';
import { format } from 'date-fns';
import { toast, ToastContainer } from 'react-toastify';
import { decryptData } from '../../Axiosinstance';

// ─────────────────────────────────────────────────────────────────
// MCQ View Dialog — admin views assessment questions + answers
// ─────────────────────────────────────────────────────────────────
const MCQViewDialog = ({ open, onClose, assessment }) => {
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading]     = useState(false);

  useEffect(() => {
    if (open && assessment?.id) fetchQuestions();
  }, [open, assessment]);

  const fetchQuestions = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`assessment_questions/${assessment.id}`);
      setQuestions(res.data);
    } catch (err) {
      toast.error("Failed to load questions");
    } finally {
      setLoading(false);
    }
  };

  const typeColors = {
    MCQ: '#1976d2', TRUE_FALSE: '#388e3c',
    MATCH: '#7b1fa2', SHORT_ANSWER: '#f57c00'
  };

  const totalMarks = questions.reduce((s, q) => s + (q.marks || 0), 0);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth
      PaperProps={{ sx: { maxHeight: '90vh' } }}>
      <DialogTitle sx={{ borderBottom: '1px solid #e0e0e0', pb: 2 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box>
            <Typography variant="h6" fontWeight="bold">
              Quiz Preview — {assessment?.description}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Module: {assessment?.moduleName} · {questions.length} questions · {totalMarks} marks total
            </Typography>
          </Box>
          <Chip label={`${questions.length} Qs`} color="primary" />
        </Box>
      </DialogTitle>

      <DialogContent sx={{ p: 3 }}>
        {loading ? (
          <Box display="flex" justifyContent="center" py={6}>
            <CircularProgress />
          </Box>
        ) : questions.length === 0 ? (
          <Typography textAlign="center" color="textSecondary" py={4}>
            No questions added yet.
          </Typography>
        ) : (
          questions.map((q, index) => (
            <Box key={q.id} sx={{
              border: `2px solid ${typeColors[q.questionType] || '#ccc'}`,
              borderRadius: 2, p: 2.5, mb: 2, backgroundColor: '#fafafa'
            }}>
              <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={1}>
                <Box sx={{ flex: 1 }}>
                  <Typography fontWeight="bold">
                    Q{index + 1}. {q.questionText}
                  </Typography>
                  <Box display="flex" gap={1} mt={0.5}>
                    <Chip label={q.questionType} size="small"
                      sx={{ backgroundColor: typeColors[q.questionType], color: 'white' }} />
                    <Chip label={`${q.marks} mark${q.marks > 1 ? 's' : ''}`}
                      size="small" color="info" variant="outlined" />
                  </Box>
                </Box>
              </Box>

              <Divider sx={{ mb: 1.5 }} />

              {/* MCQ Options with correct answer highlighted */}
              {q.questionType === 'MCQ' && (
                <Box>
                  <Typography variant="caption" fontWeight="bold" color="textSecondary" mb={1} display="block">
                    OPTIONS (✓ = correct answer)
                  </Typography>
                  {q.options?.map((opt, i) => (
                    <Box key={i} display="flex" alignItems="center" gap={1} mb={0.5} sx={{
                      backgroundColor: opt.isCorrect ? '#e8f5e9' : 'transparent',
                      borderRadius: 1, px: 1.5, py: 0.75,
                      border: `1px solid ${opt.isCorrect ? '#4caf50' : '#e0e0e0'}`
                    }}>
                      <Typography variant="body2" sx={{
                        fontWeight: opt.isCorrect ? 'bold' : 'normal',
                        color: opt.isCorrect ? 'success.main' : 'inherit',
                        flex: 1
                      }}>
                        {opt.optionText}
                      </Typography>
                      {opt.isCorrect && (
                        <Chip label="✓ Correct" size="small" color="success"
                          sx={{ height: 20, fontSize: '0.7rem' }} />
                      )}
                    </Box>
                  ))}
                </Box>
              )}

              {/* TRUE/FALSE */}
              {q.questionType === 'TRUE_FALSE' && (
                <Box>
                  <Typography variant="caption" fontWeight="bold" color="textSecondary" mb={1} display="block">
                    CORRECT ANSWER
                  </Typography>
                  <Box display="flex" gap={2}>
                    {q.options?.map((opt, i) => (
                      <Box key={i} sx={{
                        border: `2px solid ${opt.isCorrect ? '#4caf50' : '#e0e0e0'}`,
                        borderRadius: 1, px: 2.5, py: 1,
                        backgroundColor: opt.isCorrect ? '#e8f5e9' : 'transparent',
                        minWidth: 80, textAlign: 'center'
                      }}>
                        <Typography fontWeight={opt.isCorrect ? 'bold' : 'normal'}>
                          {opt.optionText}
                          {opt.isCorrect && ' ✓'}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </Box>
              )}

              {/* MATCH Pairs */}
              {q.questionType === 'MATCH' && (
                <Box>
                  <Typography variant="caption" fontWeight="bold" color="textSecondary" mb={1} display="block">
                    CORRECT PAIRS
                  </Typography>
                  {q.matchPairs?.map((pair, pi) => (
                    <Box key={pi} display="flex" alignItems="center" gap={2} mb={0.5} sx={{
                      backgroundColor: '#f3e5f5', borderRadius: 1, px: 1.5, py: 0.75
                    }}>
                      <Typography variant="body2" fontWeight="bold" sx={{ flex: 1 }}>
                        {pair.leftItem}
                      </Typography>
                      <Typography color={typeColors.MATCH} fontWeight="bold">→</Typography>
                      <Typography variant="body2" sx={{ flex: 1, color: 'success.main', fontWeight: 'bold' }}>
                        {pair.rightItem}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              )}

              {/* SHORT ANSWER */}
              {q.questionType === 'SHORT_ANSWER' && (
                <Box sx={{ backgroundColor: '#fff3e0', borderRadius: 1, p: 1.5 }}>
                  <Typography variant="body2" color={typeColors.SHORT_ANSWER}>
                    📝 Free-text response. Graded manually by the teacher.
                    No predefined answer — teacher reviews and enters marks.
                  </Typography>
                </Box>
              )}
            </Box>
          ))
        )}
      </DialogContent>

      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} variant="contained">Close</Button>
      </DialogActions>
    </Dialog>
  );
};

// ─────────────────────────────────────────────────────────────────
// FILE Edit Dialog — edit description + re-upload file only
// ─────────────────────────────────────────────────────────────────
const FileEditDialog = ({ open, onClose, assessment, batchData, onSaved }) => {
  const [description, setDescription] = useState('');
  const [newFileUrl, setNewFileUrl]    = useState('');
  const [fileUploaded, setFileUploaded] = useState(false);
  const [saving, setSaving]            = useState(false);

  const CLOUDINARY_URL    = baseURL;
  const CLOUDINARY_UPLOAD = CLOUDINARY_UPLOAD_PRESET;

  useEffect(() => {
    if (assessment) {
      setDescription(assessment.description || '');
      setNewFileUrl('');
      setFileUploaded(false);
    }
  }, [assessment]);

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const fd = new FormData();
    fd.append('file', file);
    fd.append('upload_preset', CLOUDINARY_UPLOAD);
    fd.append('public_id', `LMS/Trent/${file.name} - ${timestamp}`);
    try {
      const res  = await fetch(CLOUDINARY_URL, { method: 'POST', body: fd });
      const data = await res.json();
      if (data.secure_url) {
        setNewFileUrl(data.secure_url);
        setFileUploaded(true);
        toast.success("New file uploaded");
      }
    } catch {
      toast.error("File upload failed");
    }
  };

  const handleSave = async () => {
    if (!description.trim()) {
      toast.error("Description is required");
      return;
    }
    setSaving(true);
    try {
      const payload = {
        batchId:        assessment.batchId,
        moduleName:     assessment.moduleName, // not editable
        description,
        url:            fileUploaded ? newFileUrl : assessment.url,
        assessmentType: 'FILE',
      };
      await axios.put(`trent_assessments/${assessment.id}`, payload);
      toast.success("Assessment updated");
      onSaved();
      onClose();
    } catch {
      toast.error("Failed to update");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography variant="h6" fontWeight="bold">Edit File Assessment</Typography>
        <Typography variant="body2" color="textSecondary">
          Module: <strong>{assessment?.moduleName}</strong> (cannot be changed)
        </Typography>
      </DialogTitle>

      <DialogContent sx={{ pt: 2 }}>
        <Alert severity="info" sx={{ mb: 2 }}>
          You can only edit the <strong>description</strong> and optionally replace the file.
          The module cannot be changed.
        </Alert>

        <TextField
          label="Description" fullWidth multiline rows={3}
          value={description} sx={{ mb: 2 }}
          onChange={e => setDescription(e.target.value)}
        />

        <Box sx={{ border: '1px dashed #ccc', borderRadius: 1, p: 2, mb: 1 }}>
          <Typography variant="body2" color="textSecondary" mb={1}>
            Current file: {assessment?.url
              ? <a href={assessment.url} target="_blank" rel="noreferrer">View current file</a>
              : 'No file'}
          </Typography>
          <TextField
            type="file" fullWidth variant="outlined"
            InputLabelProps={{ shrink: true }}
            label="Replace File (optional)"
            onChange={e => {
              const file = e.target.files[0];
              if (file && file.size > 8 * 1024 * 1024) {
                e.target.value = "";
                alert("File size must be less than 8MB.");
              } else {
                handleFileChange(e);
              }
            }}
          />
          {fileUploaded && (
            <Typography variant="caption" color="success.main" mt={0.5} display="block">
              ✓ New file ready to save
            </Typography>
          )}
        </Box>
      </DialogContent>

      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} variant="outlined" color="error">Cancel</Button>
        <Button onClick={handleSave} variant="contained" disabled={saving}>
          {saving ? <CircularProgress size={20} sx={{ mr: 1 }} /> : null}
          Save Changes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

// ─────────────────────────────────────────────────────────────────
// QUIZ Edit Dialog — edit description + questions text only
//                   (options/answers NOT editable)
// ─────────────────────────────────────────────────────────────────
const QuizEditDialog = ({ open, onClose, assessment, onSaved }) => {
  const [description, setDescription] = useState('');
  const [questions, setQuestions]     = useState([]);
  const [loading, setLoading]         = useState(false);
  const [saving, setSaving]           = useState(false);

  useEffect(() => {
    if (open && assessment) {
      setDescription(assessment.description || '');
      fetchQuestions();
    }
  }, [open, assessment]);

  const fetchQuestions = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`assessment_questions/${assessment.id}`);
      setQuestions(res.data);
    } catch {
      toast.error("Failed to load questions");
    } finally {
      setLoading(false);
    }
  };

  const handleQuestionTextChange = (qIdx, value) => {
    setQuestions(prev => {
      const updated = [...prev];
      updated[qIdx] = { ...updated[qIdx], questionText: value };
      return updated;
    });
  };

  const handleSave = async () => {
    if (!description.trim()) {
      toast.error("Description is required");
      return;
    }
    setSaving(true);
    try {
      // 1. Update assessment header
      await axios.put(`trent_assessments/${assessment.id}`, {
        batchId:        assessment.batchId,
        moduleName:     assessment.moduleName,
        description,
        url:            assessment.url,
        assessmentType: 'QUIZ',
      });

      // 2. Update each question text (only text, not options)
      for (const q of questions) {
        await axios.put(`assessment_questions/${q.id}`, {
          trentAssessmentId: assessment.id,
          questionText:      q.questionText,
          questionType:      q.questionType,
          marks:             q.marks,
          orderIndex:        q.orderIndex,
          options:           q.options || [],
          matchPairs:        q.matchPairs || [],
        });
      }

      toast.success("Quiz updated successfully");
      onSaved();
      onClose();
    } catch {
      toast.error("Failed to update quiz");
    } finally {
      setSaving(false);
    }
  };

  const typeColors = {
    MCQ: '#1976d2', TRUE_FALSE: '#388e3c',
    MATCH: '#7b1fa2', SHORT_ANSWER: '#f57c00'
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth
      PaperProps={{ sx: { maxHeight: '90vh' } }}>
      <DialogTitle>
        <Typography variant="h6" fontWeight="bold">Edit Quiz Assessment</Typography>
        <Typography variant="body2" color="textSecondary">
          Module: <strong>{assessment?.moduleName}</strong> (cannot be changed)
        </Typography>
      </DialogTitle>

      <DialogContent sx={{ pt: 2 }}>
        <Alert severity="info" sx={{ mb: 2 }}>
          You can edit the <strong>description</strong> and <strong>question text</strong>.
          Options and correct answers <strong>cannot</strong> be changed to preserve result integrity.
        </Alert>

        <TextField
          label="Description" fullWidth multiline rows={2}
          value={description} sx={{ mb: 3 }}
          onChange={e => setDescription(e.target.value)}
        />

        {loading ? (
          <Box display="flex" justifyContent="center" py={4}>
            <CircularProgress />
          </Box>
        ) : (
          questions.map((q, qIdx) => (
            <Box key={q.id} sx={{
              border: `2px solid ${typeColors[q.questionType] || '#ccc'}`,
              borderRadius: 2, p: 2, mb: 2, backgroundColor: '#fafafa'
            }}>
              <Box display="flex" gap={1} alignItems="center" mb={1}>
                <Chip label={`Q${qIdx + 1}`} size="small" />
                <Chip label={q.questionType} size="small"
                  sx={{ backgroundColor: typeColors[q.questionType], color: 'white' }} />
                <Chip label={`${q.marks} mark${q.marks > 1 ? 's' : ''}`}
                  size="small" color="info" variant="outlined" />
                <Typography variant="caption" color="textSecondary" sx={{ ml: 'auto' }}>
                  Question text only — options locked
                </Typography>
              </Box>

              <TextField
                label={`Question ${qIdx + 1} Text`}
                fullWidth multiline rows={2} size="small"
                value={q.questionText}
                onChange={e => handleQuestionTextChange(qIdx, e.target.value)}
                sx={{ mb: 1 }}
              />

              {/* Read-only options preview */}
              {(q.questionType === 'MCQ' || q.questionType === 'TRUE_FALSE') && q.options?.length > 0 && (
                <Box sx={{ backgroundColor: '#f5f5f5', borderRadius: 1, p: 1 }}>
                  <Typography variant="caption" color="textSecondary" fontWeight="bold">
                    OPTIONS (read-only):
                  </Typography>
                  {q.options.map((opt, i) => (
                    <Box key={i} display="flex" alignItems="center" gap={1} mt={0.5}>
                      <Box sx={{
                        width: 8, height: 8, borderRadius: '50%',
                        backgroundColor: opt.isCorrect ? '#4caf50' : '#bbb'
                      }} />
                      <Typography variant="caption" sx={{
                        color: opt.isCorrect ? 'success.main' : 'inherit',
                        fontWeight: opt.isCorrect ? 'bold' : 'normal'
                      }}>
                        {opt.optionText} {opt.isCorrect ? '✓' : ''}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              )}

              {q.questionType === 'MATCH' && q.matchPairs?.length > 0 && (
                <Box sx={{ backgroundColor: '#f5f5f5', borderRadius: 1, p: 1 }}>
                  <Typography variant="caption" color="textSecondary" fontWeight="bold">
                    MATCH PAIRS (read-only):
                  </Typography>
                  {q.matchPairs.map((pair, i) => (
                    <Typography key={i} variant="caption" display="block" mt={0.5}>
                      {pair.leftItem} → {pair.rightItem}
                    </Typography>
                  ))}
                </Box>
              )}

              {q.questionType === 'SHORT_ANSWER' && (
                <Box sx={{ backgroundColor: '#fff3e0', borderRadius: 1, p: 1 }}>
                  <Typography variant="caption" color={typeColors.SHORT_ANSWER}>
                    📝 Free-text. Manually graded.
                  </Typography>
                </Box>
              )}
            </Box>
          ))
        )}
      </DialogContent>

      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} variant="outlined" color="error">Cancel</Button>
        <Button onClick={handleSave} variant="contained" disabled={saving}>
          {saving ? <CircularProgress size={20} sx={{ mr: 1 }} /> : null}
          Save Changes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

// ─────────────────────────────────────────────────────────────────
// Main Admin Assessment Page
// ─────────────────────────────────────────────────────────────────
const App = () => {
  const { id: encodedBatchId } = useParams();
  const id = decryptData(encodedBatchId);

  const [rows, setRows]         = useState([]);
  const [open, setOpen]         = useState(false);
  const [page, setPage]         = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [batchData, setBatchData]    = useState(null);
  const [fileUploaded, setFileUploaded] = useState(false);

  // Step tracking for QUIZ: 'form' | 'questions'
  const [step, setStep]                   = useState('form');
  const [savedAssessmentId, setSavedAssessmentId] = useState(null);

  const [formData, setFormData] = useState({
    description: '', moduleName: '', url: '', assessmentType: 'FILE',
  });

  const [questions, setQuestions] = useState([]);

  // Edit dialogs
  const [fileEditOpen, setFileEditOpen]   = useState(false);
  const [quizEditOpen, setQuizEditOpen]   = useState(false);
  const [viewQuizOpen, setViewQuizOpen]   = useState(false);
  const [selectedAssessment, setSelectedAssessment] = useState(null);

  // Delete confirmation
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteTarget, setDeleteTarget]         = useState(null);
  const [deleteError, setDeleteError]           = useState('');
  const [deleteChecking, setDeleteChecking]     = useState(false);

  const CLOUDINARY_URL    = baseURL;
  const CLOUDINARY_UPLOAD = CLOUDINARY_UPLOAD_PRESET;

  useEffect(() => {
    fetchBatchData();
    fetchAssessmentData();
  }, []);

  const resetModal = () => {
    setFormData({ description: '', moduleName: '', url: '', assessmentType: 'FILE' });
    setQuestions([]);
    setSavedAssessmentId(null);
    setStep('form');
    setFileUploaded(false);
  };

  const handleOpen  = () => { resetModal(); setOpen(true); };
  const handleClose = () => { setOpen(false); resetModal(); };

  const fetchBatchData = async () => {
    try {
      const res = await axios.get(`batch/${id}`);
      setBatchData(res.data);
    } catch (err) { console.error(err); }
  };

  const fetchAssessmentData = async () => {
    try {
      const res = await axios.get(`trent_assessments/${id}`);
      setRows(res.data);
    } catch (err) { console.error(err); }
  };

  // ── Delete with submission check ─────────────────────────────
  const handleDeleteClick = async (row) => {
    setDeleteTarget(row);
    setDeleteError('');
    setDeleteChecking(true);
    setDeleteDialogOpen(true);

    try {
      // Check if any submissions exist for this assessment
      const res = await axios.get(
        row.assessmentType === 'QUIZ'
          ? `quiz/submissions/count/${row.id}`
          : `submissions/${row.id}`
      );

      const count = row.assessmentType === 'QUIZ'
        ? (res.data?.count ?? res.data?.length ?? res.data ?? 0)
        : (Array.isArray(res.data) ? res.data.length : 0);

      if (count > 0) {
        setDeleteError(
          `Cannot delete: ${count} student submission${count > 1 ? 's' : ''} reference this assessment. Remove all submissions first.`
        );
      }
    } catch (err) {
      // If endpoint doesn't exist yet, allow delete (safe fallback)
      console.warn("Could not check submissions:", err);
    } finally {
      setDeleteChecking(false);
    }
  };

  const confirmDelete = async () => {
    if (deleteError) return;
    try {
      await axios.delete(`trent_assessments/${deleteTarget.id}`);
      setRows(prev => prev.filter(r => r.id !== deleteTarget.id));
      toast.success("Deleted successfully");
    } catch {
      toast.error("Delete failed");
    } finally {
      setDeleteDialogOpen(false);
      setDeleteTarget(null);
    }
  };

  // ── Edit routing ─────────────────────────────────────────────
  const handleEditClick = (row) => {
    setSelectedAssessment({ ...row, batchId: id });
    if (row.assessmentType === 'QUIZ') {
      setQuizEditOpen(true);
    } else {
      setFileEditOpen(true);
    }
  };

  // ── View Quiz ────────────────────────────────────────────────
  const handleViewQuiz = (row) => {
    setSelectedAssessment(row);
    setViewQuizOpen(true);
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const fd = new FormData();
    fd.append('file', file);
    fd.append('upload_preset', CLOUDINARY_UPLOAD);
    fd.append('public_id', `LMS/Trent/${file.name} - ${timestamp}`);
    try {
      const res  = await fetch(CLOUDINARY_URL, { method: 'POST', body: fd });
      const data = await res.json();
      if (data.secure_url) {
        setFormData(prev => ({ ...prev, url: data.secure_url }));
        setFileUploaded(true);
        toast.success("File uploaded");
      }
    } catch {
      toast.error("File upload failed");
    }
  };

  // ── Step 1: Save new assessment ──────────────────────────────
  const handleSaveAssessment = async () => {
    if (!formData.moduleName || !formData.description) {
      toast.error("Please fill Module and Description");
      return;
    }
    const payload = {
      batchId: id,
      description: formData.description,
      moduleName: formData.moduleName,
      url: formData.assessmentType === 'FILE' ? formData.url : '',
      assessmentType: formData.assessmentType,
    };
    try {
      const response = await axios.post('trent_assessments/upload', payload);
      if (formData.assessmentType === 'QUIZ') {
        const newId = response.data?.id;
        if (!newId) { toast.error("Failed to get assessment ID."); return; }
        setSavedAssessmentId(newId);
        setStep('questions');
        toast.success("Assessment saved! Now add questions.");
        fetchAssessmentData();
      } else {
        toast.success("Assessment created");
        fetchAssessmentData();
        handleClose();
      }
    } catch {
      toast.error("Failed to save assessment");
    }
  };

  // ── Step 2: Save all questions (new quiz) ────────────────────
  const handleSaveAllQuestions = async () => {
    if (questions.length === 0) { toast.error("Add at least one question"); return; }
    for (let i = 0; i < questions.length; i++) {
      const q = questions[i];
      if (!q.questionText.trim()) { toast.error(`Question ${i + 1} text is empty`); return; }
      if (q.questionType === 'MCQ' && q.options.filter(o => o.optionText.trim()).length < 2) {
        toast.error(`Question ${i + 1} needs at least 2 options`); return;
      }
      if (q.questionType === 'MCQ' && !q.options.some(o => o.isCorrect)) {
        toast.error(`Question ${i + 1}: select a correct answer`); return;
      }
      if (q.questionType === 'MATCH' && q.matchPairs.length < 1) {
        toast.error(`Question ${i + 1} needs at least 1 match pair`); return;
      }
    }
    try {
      for (const q of questions) {
        await axios.post('assessment_questions/add', {
          trentAssessmentId: savedAssessmentId,
          questionText: q.questionText,
          questionType: q.questionType,
          marks: q.marks,
          orderIndex: q.orderIndex,
          options: (q.questionType === 'MCQ' || q.questionType === 'TRUE_FALSE') ? q.options : [],
          matchPairs: q.questionType === 'MATCH' ? q.matchPairs : [],
        });
      }
      toast.success(`${questions.length} question(s) saved!`);
      handleClose();
    } catch {
      toast.error("Failed to save questions");
    }
  };

  // ── Question helpers ─────────────────────────────────────────
  const addQuestion = () => {
    setQuestions(prev => [...prev, {
      questionText: '', questionType: 'MCQ', marks: 1, orderIndex: prev.length + 1,
      options: [
        { optionText: '', isCorrect: false }, { optionText: '', isCorrect: false },
        { optionText: '', isCorrect: false }, { optionText: '', isCorrect: false },
      ],
      matchPairs: [],
    }]);
  };

  const removeQuestion = (qIdx) => setQuestions(prev => prev.filter((_, i) => i !== qIdx));

  const updateQuestion = (qIdx, field, value) => {
    setQuestions(prev => {
      const updated = [...prev];
      updated[qIdx] = { ...updated[qIdx], [field]: value };
      if (field === 'questionType') {
        if (value === 'TRUE_FALSE') {
          updated[qIdx].options = [
            { optionText: 'True', isCorrect: true },
            { optionText: 'False', isCorrect: false },
          ];
          updated[qIdx].matchPairs = [];
        } else if (value === 'MCQ') {
          updated[qIdx].options = [
            { optionText: '', isCorrect: false }, { optionText: '', isCorrect: false },
            { optionText: '', isCorrect: false }, { optionText: '', isCorrect: false },
          ];
          updated[qIdx].matchPairs = [];
        } else if (value === 'MATCH') {
          updated[qIdx].options = [];
          updated[qIdx].matchPairs = [{ leftItem: '', rightItem: '' }, { leftItem: '', rightItem: '' }];
        } else if (value === 'SHORT_ANSWER') {
          updated[qIdx].options = [];
          updated[qIdx].matchPairs = [];
        }
      }
      return updated;
    });
  };

  const updateOption = (qIdx, oIdx, field, value) => {
    setQuestions(prev => {
      const updated = [...prev];
      const opts = [...updated[qIdx].options];
      if (field === 'isCorrect') {
        opts.forEach((o, i) => { opts[i] = { ...o, isCorrect: i === oIdx }; });
      } else {
        opts[oIdx] = { ...opts[oIdx], [field]: value };
      }
      updated[qIdx].options = opts;
      return updated;
    });
  };

  const addOption    = (qIdx) => setQuestions(prev => {
    const updated = [...prev];
    updated[qIdx].options.push({ optionText: '', isCorrect: false });
    return updated;
  });

  const removeOption = (qIdx, oIdx) => setQuestions(prev => {
    const updated = [...prev];
    updated[qIdx].options = updated[qIdx].options.filter((_, i) => i !== oIdx);
    return updated;
  });

  const updateMatchPair = (qIdx, pIdx, field, value) => {
    setQuestions(prev => {
      const updated = [...prev];
      const pairs = [...updated[qIdx].matchPairs];
      pairs[pIdx] = { ...pairs[pIdx], [field]: value };
      updated[qIdx].matchPairs = pairs;
      return updated;
    });
  };

  const addMatchPair    = (qIdx) => setQuestions(prev => {
    const updated = [...prev];
    updated[qIdx].matchPairs.push({ leftItem: '', rightItem: '' });
    return updated;
  });

  const removeMatchPair = (qIdx, pIdx) => setQuestions(prev => {
    const updated = [...prev];
    updated[qIdx].matchPairs = updated[qIdx].matchPairs.filter((_, i) => i !== pIdx);
    return updated;
  });

  const isSaveDisabled = () => {
    if (!formData.description || !formData.moduleName) return true;
    if (formData.assessmentType === 'FILE' && !fileUploaded) return true;
    return false;
  };

  const typeColors = {
    MCQ: '#1976d2', TRUE_FALSE: '#388e3c',
    MATCH: '#7b1fa2', SHORT_ANSWER: '#f57c00'
  };

  return (
    <div>
      <Header />
      <br />
      <Box p={4}>
        <TableContainer component={Paper}>
          <Box display="flex" gap={2} mb={2} p={1}>
            <Link to="/Allcourse">
              <Button variant="contained" sx={{ backgroundColor: '#007bff' }}>All Courses</Button>
            </Link>
            <Button variant="contained" sx={{ backgroundColor: '#007bff' }} onClick={handleOpen}>
              Add New Template
            </Button>
          </Box>

          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 'bold' }}>Description</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Type</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Created At</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Module</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.length > 0 ? (
                rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
                  <TableRow key={index}>
                    <TableCell>{row.description}</TableCell>
                    <TableCell>
                      <Chip label={row.assessmentType || 'FILE'}
                        color={row.assessmentType === 'QUIZ' ? 'secondary' : 'primary'} size="small" />
                    </TableCell>
                    <TableCell>
                      {row.createdAt ? format(new Date(row.createdAt), 'dd/MM/yyyy HH:mm') : 'N/A'}
                    </TableCell>
                    <TableCell>{row.moduleName}</TableCell>
                    <TableCell>
                      <Box display="flex" gap={0.5} flexWrap="wrap">
                        {/* View — only for QUIZ */}
                        {row.assessmentType === 'QUIZ' && (
                          <Button variant="outlined" color="info" size="small"
                            startIcon={<VisibilityIcon />}
                            onClick={() => handleViewQuiz(row)}>
                            View
                          </Button>
                        )}
                        {/* View File — only for FILE */}
                        {row.assessmentType !== 'QUIZ' && (
                          <Button variant="outlined" color="primary" size="small"
                            onClick={() => window.open(row.url, "_blank")}>
                            View File
                          </Button>
                        )}
                        {/* Edit */}
                        <Button variant="outlined" color="success" size="small"
                          startIcon={<EditIcon />}
                          onClick={() => handleEditClick(row)}>
                          Edit
                        </Button>
                        {/* Delete */}
                        <Button variant="outlined" color="error" size="small"
                          startIcon={<DeleteIcon />}
                          onClick={() => handleDeleteClick(row)}>
                          Delete
                        </Button>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={5} align="center">No data available</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>

          <TablePagination rowsPerPageOptions={[5, 10, 15]} component="div"
            count={rows.length} rowsPerPage={rowsPerPage} page={page}
            onPageChange={(e, n) => setPage(n)}
            onRowsPerPageChange={e => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); }} />
        </TableContainer>

        {/* ── CREATE Modal ─────────────────────────────────────── */}
        <Modal open={open} onClose={handleClose}>
          <Box component={Paper} sx={{
            width: '90%', maxWidth: 750,
            maxHeight: '90vh', overflowY: 'auto',
            margin: 'auto', mt: '3%', p: 4, borderRadius: 2,
          }}>
            {step === 'form' && (
              <>
                <Typography variant="h6" textAlign="center" color="primary" mb={2}>
                  Add New Assessment
                </Typography>

                <Box mb={2}>
                  <FormLabel sx={{ fontWeight: 'bold' }}>Assessment Type</FormLabel>
                  <RadioGroup row value={formData.assessmentType}
                    onChange={e => setFormData({ ...formData, assessmentType: e.target.value })}>
                    <FormControlLabel value="FILE" control={<Radio />} label="File Upload" />
                    <FormControlLabel value="QUIZ" control={<Radio />} label="Quiz (MCQ / T-F / Match / Short Answer)" />
                  </RadioGroup>
                </Box>

                <TextField select label="Module" fullWidth variant="outlined" sx={{ mb: 2 }}
                  value={formData.moduleName}
                  onChange={e => setFormData({ ...formData, moduleName: e.target.value })}>
                  {batchData?.moduleDetails?.length > 0
                    ? batchData.moduleDetails.map(m => (
                      <MenuItem key={m.id} value={m.moduleName}>{m.moduleName}</MenuItem>
                    ))
                    : <MenuItem disabled>No modules available</MenuItem>}
                </TextField>

                <TextField label="Description" fullWidth multiline rows={3}
                  variant="outlined" sx={{ mb: 2 }}
                  value={formData.description}
                  onChange={e => setFormData({ ...formData, description: e.target.value })} />

                {formData.assessmentType === 'FILE' && (
                  <TextField type="file" fullWidth variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    label="Upload File" sx={{ mb: 2 }}
                    onChange={e => {
                      const file = e.target.files[0];
                      if (file && file.size > 8 * 1024 * 1024) {
                        e.target.value = ""; alert("File size must be less than 8MB.");
                      } else { handleFileChange(e); }
                    }} />
                )}

                <Box display="flex" gap={2}>
                  <Button variant="contained" color="primary"
                    disabled={isSaveDisabled()} onClick={handleSaveAssessment}>
                    {formData.assessmentType === 'QUIZ'
                      ? 'Save & Add Questions →' : 'Save'}
                  </Button>
                  <Button variant="outlined" color="error" onClick={handleClose}>Cancel</Button>
                </Box>
              </>
            )}

            {step === 'questions' && (
              <>
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                  <Box>
                    <Typography variant="h6" color="primary" fontWeight="bold">Add Questions</Typography>
                    <Typography variant="body2" color="textSecondary">
                      Assessment ID: {savedAssessmentId} · {questions.length} question(s)
                    </Typography>
                  </Box>
                  <Button variant="contained" color="primary" startIcon={<AddIcon />} onClick={addQuestion}>
                    Add Question
                  </Button>
                </Box>

                <Divider sx={{ mb: 2 }} />

                {questions.length === 0 && (
                  <Box textAlign="center" py={4} sx={{ border: '2px dashed #ccc', borderRadius: 2 }}>
                    <Typography color="textSecondary" mb={1}>No questions yet</Typography>
                    <Button variant="outlined" startIcon={<AddIcon />} onClick={addQuestion}>
                      Add First Question
                    </Button>
                  </Box>
                )}

                {questions.map((q, qIdx) => (
                  <Box key={qIdx} sx={{
                    border: `2px solid ${typeColors[q.questionType] || '#ccc'}`,
                    borderRadius: 2, p: 2, mb: 2, backgroundColor: '#fafafa'
                  }}>
                    <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                      <Typography fontWeight="bold" color={typeColors[q.questionType]}>
                        Question {qIdx + 1}
                      </Typography>
                      <IconButton color="error" size="small" onClick={() => removeQuestion(qIdx)}>
                        <DeleteIcon />
                      </IconButton>
                    </Box>

                    <Box display="flex" gap={2} mb={1}>
                      <TextField select label="Question Type" size="small"
                        value={q.questionType} sx={{ flex: 2 }}
                        onChange={e => updateQuestion(qIdx, 'questionType', e.target.value)}>
                        {Object.entries(typeColors).map(([type, color]) => (
                          <MenuItem key={type} value={type}>
                            <Box display="flex" alignItems="center" gap={1}>
                              <Chip label={type} size="small" sx={{ backgroundColor: color, color: 'white' }} />
                              {type === 'MCQ' ? 'Multiple Choice' : type === 'TRUE_FALSE' ? 'True / False'
                                : type === 'MATCH' ? 'Match the Following' : 'Short Answer'}
                            </Box>
                          </MenuItem>
                        ))}
                      </TextField>
                      <TextField label="Marks" type="number" size="small"
                        value={q.marks} sx={{ width: 90 }} inputProps={{ min: 1 }}
                        onChange={e => updateQuestion(qIdx, 'marks', parseInt(e.target.value) || 1)} />
                    </Box>

                    <TextField label={`Question ${qIdx + 1} Text`} fullWidth multiline rows={2}
                      size="small" value={q.questionText} sx={{ mb: 1 }}
                      onChange={e => updateQuestion(qIdx, 'questionText', e.target.value)} />

                    {/* MCQ */}
                    {q.questionType === 'MCQ' && (
                      <Box sx={{ backgroundColor: '#e3f2fd', borderRadius: 1, p: 1.5 }}>
                        <Typography variant="body2" fontWeight="bold" color={typeColors.MCQ} mb={1}>
                          Options — select the correct answer (●)
                        </Typography>
                        {q.options.map((opt, oIdx) => (
                          <Box key={oIdx} display="flex" alignItems="center" gap={1} mb={0.5}>
                            <Radio size="small" checked={opt.isCorrect}
                              onChange={() => updateOption(qIdx, oIdx, 'isCorrect', true)}
                              sx={{ color: typeColors.MCQ }} />
                            <TextField size="small" fullWidth placeholder={`Option ${oIdx + 1}`}
                              value={opt.optionText}
                              onChange={e => updateOption(qIdx, oIdx, 'optionText', e.target.value)} />
                            {q.options.length > 2 && (
                              <IconButton size="small" color="error" onClick={() => removeOption(qIdx, oIdx)}>
                                <DeleteIcon fontSize="small" />
                              </IconButton>
                            )}
                          </Box>
                        ))}
                        <Button size="small" startIcon={<AddIcon />} onClick={() => addOption(qIdx)} sx={{ mt: 0.5 }}>
                          Add Option
                        </Button>
                      </Box>
                    )}

                    {/* TRUE/FALSE */}
                    {q.questionType === 'TRUE_FALSE' && (
                      <Box sx={{ backgroundColor: '#e8f5e9', borderRadius: 1, p: 1.5 }}>
                        <Typography variant="body2" fontWeight="bold" color={typeColors.TRUE_FALSE} mb={1}>
                          Select the correct answer
                        </Typography>
                        <RadioGroup row value={q.options.find(o => o.isCorrect)?.optionText || 'True'}
                          onChange={e => setQuestions(prev => {
                            const updated = [...prev];
                            updated[qIdx].options = [
                              { optionText: 'True', isCorrect: e.target.value === 'True' },
                              { optionText: 'False', isCorrect: e.target.value === 'False' },
                            ];
                            return updated;
                          })}>
                          <FormControlLabel value="True" control={<Radio sx={{ color: typeColors.TRUE_FALSE }} />}
                            label={<Typography fontWeight="bold">✓ True</Typography>} />
                          <FormControlLabel value="False" control={<Radio sx={{ color: typeColors.TRUE_FALSE }} />}
                            label={<Typography fontWeight="bold">✗ False</Typography>} />
                        </RadioGroup>
                      </Box>
                    )}

                    {/* MATCH */}
                    {q.questionType === 'MATCH' && (
                      <Box sx={{ backgroundColor: '#f3e5f5', borderRadius: 1, p: 1.5 }}>
                        <Typography variant="body2" fontWeight="bold" color={typeColors.MATCH} mb={1}>
                          Match Pairs — Left column → Right column
                        </Typography>
                        {q.matchPairs.map((pair, pIdx) => (
                          <Box key={pIdx} display="flex" alignItems="center" gap={1} mb={0.5}>
                            <TextField size="small" placeholder="Left item" value={pair.leftItem} sx={{ flex: 1 }}
                              onChange={e => updateMatchPair(qIdx, pIdx, 'leftItem', e.target.value)} />
                            <Typography color={typeColors.MATCH} fontWeight="bold">→</Typography>
                            <TextField size="small" placeholder="Right item" value={pair.rightItem} sx={{ flex: 1 }}
                              onChange={e => updateMatchPair(qIdx, pIdx, 'rightItem', e.target.value)} />
                            {q.matchPairs.length > 1 && (
                              <IconButton size="small" color="error" onClick={() => removeMatchPair(qIdx, pIdx)}>
                                <DeleteIcon fontSize="small" />
                              </IconButton>
                            )}
                          </Box>
                        ))}
                        <Button size="small" startIcon={<AddIcon />} onClick={() => addMatchPair(qIdx)} sx={{ mt: 0.5 }}>
                          Add Pair
                        </Button>
                      </Box>
                    )}

                    {/* SHORT ANSWER — shows expected answer field for reference */}
                    {q.questionType === 'SHORT_ANSWER' && (
                      <Box sx={{ backgroundColor: '#fff3e0', borderRadius: 1, p: 1.5 }}>
                        <Typography variant="body2" color={typeColors.SHORT_ANSWER} mb={1}>
                          📝 Student types a free-text answer. Graded manually by the teacher.
                        </Typography>
                        <TextField
                          label="Model Answer / Marking Guide (optional — for teacher reference only)"
                          fullWidth multiline rows={2} size="small"
                          placeholder="Enter expected answer or marking criteria..."
                          helperText="This is only visible to the teacher when grading, not shown to students."
                        />
                      </Box>
                    )}
                  </Box>
                ))}

                <Box display="flex" gap={2} mt={2}>
                  <Button variant="contained" color="success"
                    disabled={questions.length === 0} onClick={handleSaveAllQuestions}>
                    Save All Questions ({questions.length}) ✓
                  </Button>
                  <Button variant="outlined" color="error" onClick={handleClose}>Cancel</Button>
                </Box>
              </>
            )}
          </Box>
        </Modal>
      </Box>

      {/* ── Delete Confirmation Dialog ───────────────────────── */}
      <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          {deleteChecking ? (
            <Box display="flex" alignItems="center" gap={2}>
              <CircularProgress size={20} />
              <Typography>Checking for student submissions...</Typography>
            </Box>
          ) : deleteError ? (
            <Alert severity="error">{deleteError}</Alert>
          ) : (
            <Typography>
              Are you sure you want to delete <strong>"{deleteTarget?.description}"</strong>?
              This action cannot be undone.
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialogOpen(false)} variant="outlined">Cancel</Button>
          <Button onClick={confirmDelete} variant="contained" color="error"
            disabled={!!deleteError || deleteChecking}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── FILE Edit Dialog ─────────────────────────────────── */}
      <FileEditDialog
        open={fileEditOpen}
        onClose={() => setFileEditOpen(false)}
        assessment={selectedAssessment}
        batchData={batchData}
        onSaved={fetchAssessmentData}
      />

      {/* ── QUIZ Edit Dialog ─────────────────────────────────── */}
      <QuizEditDialog
        open={quizEditOpen}
        onClose={() => setQuizEditOpen(false)}
        assessment={selectedAssessment}
        onSaved={fetchAssessmentData}
      />

      {/* ── MCQ View Dialog ──────────────────────────────────── */}
      <MCQViewDialog
        open={viewQuizOpen}
        onClose={() => setViewQuizOpen(false)}
        assessment={selectedAssessment}
      />

      <ToastContainer position="bottom-right" autoClose={3000} hideProgressBar />
    </div>
  );
};

export default App;